import { moduleApi } from '@/api/module.api';
import { CreateModuleDTO } from '@/jbi-shared/dto/jtms.dtos';
import { Store } from 'vuex';
import {
  ModuleQueryParams,
  ModuleState,
  UpdateModuleApiDTO
} from './module.types';

export const moduleActions = {
  async getModules(store: Store<ModuleState>) {
    try {
      store.commit('GET_MODULES_LOADING');

      const { data } = await moduleApi.getModules();

      store.commit('GET_MODULES_SUCCESS', data);
    } catch (error) {
      store.commit('GET_MODULES_ERROR', error);
    }
  },

  async getPaginatedModules(
    store: Store<ModuleState>,
    payload: ModuleQueryParams
  ) {
    try {
      store.commit('GET_PAGINATED_MODULES_LOADING');

      const { data } = await moduleApi.getPaginatedModules(payload);

      store.commit('GET_PAGINATED_MODULES_SUCCESS', data);

      return data;
    } catch (error) {
      store.commit('GET_PAGINATED_MODULES_ERROR', error);
      throw error;
    }
  },

  async createModule(store: Store<ModuleState>, payload: CreateModuleDTO) {
    try {
      store.commit('CREATE_MODULE_LOADING');

      await moduleApi.createModule(payload);

      store.dispatch('getModules');
      store.commit('CREATE_MODULE_SUCCESS');
    } catch (error) {
      store.commit('CREATE_MODULE_ERROR', error);
      throw error;
    }
  },

  async updateModule(store: Store<ModuleState>, payload: UpdateModuleApiDTO) {
    try {
      store.commit('UPDATE_MODULE_LOADING');

      await moduleApi.updateModule(payload);

      store.dispatch('getModules');
      store.commit('UPDATE_MODULE_SUCCESS');
    } catch (error) {
      store.commit('UPDATE_MODULE_ERROR', error);
      throw error;
    }
  }
};
